import { __awaiter } from "tslib";
import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
import { toNumber } from '@/shared/functions';
import { notification } from 'antd';
const initState = {
    notEqualToHandPrice: false,
    showNormalDeal: false,
    sellerPriceYuanUnit: '',
    transferMode: true,
    orderId: '',
    callback: null,
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        /** 正常成交 */
        doNormalDeal(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                return Api.order.normalDeal(payload).then((r) => {
                    return r;
                }).catch((e) => {
                    return false;
                });
            });
        },
        /** 点击确定 */
        handleOk(payload, { update, state, rootState }) {
            console.log(payload, 'payload');
            const { orderId } = state;
            payload.form.validateFields((error, values) => {
                if (!error) {
                    // 校验中标价
                    this.checkHandPrice(payload).then((_r) => {
                        /** 等于中标价*/
                        if (_r) {
                            // 参数需要调整
                            const _params = {
                                orderId,
                                priorityOffer: values.priorityOffer,
                                remark: values.remark,
                                transferType: values.transferType ? values.transferType : '666',
                            };
                            // 请求正常成交接口
                            this.doNormalDeal(_params).then((_r) => {
                                if (_r) {
                                    // 有 获取全部值 请求数据 成功后
                                    notification.success({
                                        message: '正常成交成功',
                                    });
                                    this.CloseModal();
                                    this.RESET_STATE();
                                    state.callback && state.callback(state.orderId);
                                    payload.form.resetFields();
                                }
                                else {
                                    notification.error({
                                        message: '正常成交失败',
                                    });
                                }
                            }).catch(() => {
                                notification.error({
                                    message: '正常成交失败',
                                });
                            });
                        }
                        /** 不等于合手价 */
                        else {
                            this.SET_STATE({ notEqualToHandPrice: true });
                        }
                    });
                }
            });
        },
        /** 点击取消或叉号 */
        handleCancel(payload, { update, state, rootState }) {
            this.RESET_STATE();
            payload.form.resetFields();
            this.CloseModal();
        },
        /** 校验 修改后中标价与原中标价是否相等，不相等报错*/
        checkHandPrice(payload, { update, state, rootState }) {
            return new Promise((resolve) => {
                const { sellerPriceYuanUnit } = state; // 原有的中标价
                const { priorityOffer } = payload.form.getFieldsValue(); // 修改后的中标价
                if (toNumber(priorityOffer) <= toNumber(sellerPriceYuanUnit)) {
                    payload.form.setFields({
                        winningPrice: { value: sellerPriceYuanUnit, errors: [new Error(' ')] },
                    });
                    resolve(true);
                }
                resolve(false);
            });
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                state[key] = payload[key];
            });
        },
        ShowModal(state, { sellerPriceYuanUnit, transferMode, orderId, callback }) {
            state.showNormalDeal = true;
            state.sellerPriceYuanUnit = sellerPriceYuanUnit;
            state.transferMode = transferMode;
            state.orderId = orderId;
            state.callback = callback;
        },
        CloseModal(state) {
            state.showNormalDeal = false;
        },
    },
});
